const getWindowConfig = () => {
  if (typeof window === 'undefined' || !window.__RUNTIME_CONFIG__) {
    return {};
  }

  return window.__RUNTIME_CONFIG__;
};

const getConfigValue = key => {
  const runtimeConfig = getWindowConfig();
  if (Object.prototype.hasOwnProperty.call(runtimeConfig, key)) {
    const runtimeValue = runtimeConfig[key];
    return runtimeValue;
  }

  return process.env[key] || '';
};

const normalizeHostname = hostname => {
  return (hostname || '').replace(/^www\./, '');
};

const isLocalHostname = hostname => {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]' ||
    /^\d+\.\d+\.\d+\.\d+$/.test(hostname)
  );
};

export const getAppStage = () => getConfigValue('REACT_APP_STAGE');

export const getTestSlug = () => getConfigValue('REACT_APP_TEST_SLUG').trim();

export const getBaseApiUrl = () => {
  const configuredBaseApi = getConfigValue('REACT_APP_BASE_API').trim();
  if (configuredBaseApi) {
    return configuredBaseApi;
  }

  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api/v1`;
  }

  return '';
};

export const getBaseDomain = hostname => {
  const configuredDomain = getConfigValue('REACT_APP_DOMAIN').trim();
  if (configuredDomain) {
    return configuredDomain;
  }

  const normalizedHostname = normalizeHostname(hostname);
  if (!normalizedHostname || isLocalHostname(normalizedHostname)) {
    return normalizedHostname;
  }

  const hostnameParts = normalizedHostname.split('.');
  if (hostnameParts.length <= 2) {
    return normalizedHostname;
  }

  return hostnameParts.slice(1).join('.');
};

export const getRuntimeSubdomain = hostname => {
  const normalizedHostname = normalizeHostname(hostname);
  const baseDomain = getBaseDomain(normalizedHostname);

  if (!normalizedHostname || !baseDomain || normalizedHostname === baseDomain || isLocalHostname(normalizedHostname)) {
    return '';
  }

  const suffix = `.${baseDomain}`;
  if (!normalizedHostname.endsWith(suffix)) {
    return '';
  }

  const prefix = normalizedHostname.slice(0, -suffix.length);
  return prefix.split('.')[0] || '';
};
